import { render, staticRenderFns } from "./SpecAutoChoosePopupWrappable.vue?vue&type=template&id=937a9c44&scoped=true&lang=pug&"
import script from "./SpecAutoChoosePopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecAutoChoosePopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecAutoChoosePopupWrappable.vue?vue&type=style&index=0&id=937a9c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a9c44",
  null
  
)

export default component.exports